export const genericCodesService = {
    getGenType,
    getGenCode,
    isJsonString,
    getPinpad
};

function isJsonString(str) {
    if (str === null) {
        return false
    }
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}


function getPinpad() {
    return new Promise((resolve, reject) => {
        let pinpadObject = { pinpad: '' };
        let myPinpadString = sessionStorage.getItem('pinpad');
        if (isJsonString(myPinpadString)) {

            pinpadObject = JSON.parse(myPinpadString);
            resolve(pinpadObject)
        }
        else {
            getGenCode('SYSTEM_PARAM', 'PINPAD_LST')
            .then(genCodeObj => {
                console.log(genCodeObj);

                let pinpadObject = { 'pinpad': genCodeObj.GEN_DESC }
                sessionStorage.setItem('pinpad', JSON.stringify(pinpadObject));
                resolve(pinpadObject)
            })
            .catch(err => {
                reject(err)
            });

        }
    })
}

function getGenType(gen_type) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return fetch(`${process.env.REACT_APP_REST_URL}/generic_codes/${gen_type}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        }).catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}
function getGenCode(gen_type, gen_code) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return fetch(`${process.env.REACT_APP_REST_URL}/generic_codes/${gen_type}/${gen_code}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        }).catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        if (response.ok) {
            const data = text && JSON.parse(text);
            console.log(data);
            return data;
        } else {
            console.log(`-------- ${text} --------`);
            return Promise.reject(response.statusText);
        }
    });
}